import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export function Hero2() {
  const { t } = useTranslation();

  return (
    <div className="relative bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="relative z-10 bg-white lg:max-w-2xl lg:w-full">
          <svg
            className="hidden lg:block absolute right-0 inset-y-0 h-full w-48 text-white transform translate-x-1/2"
            fill="currentColor"
            viewBox="0 0 100 100"
            preserveAspectRatio="none"
            aria-hidden="true"
          >
            <polygon points="50,0 100,0 50,100 0,100" />
          </svg>

          <main className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="sm:text-center lg:text-left pt-20 pb-14 sm:pt-24 sm:pb-20 lg:pt-32 lg:pb-28">
              <h1 className="text-4xl tracking-tight font-extrabold text-gray-900 sm:text-5xl md:text-6xl">
                <span className="block">Your unified Gateway</span>
                <span className="block text-[#3C7CD6]">to PMS Providers</span>
              </h1>
              <p className="mt-3 text-base text-gray-500 sm:mt-5 sm:text-lg sm:max-w-xl sm:mx-auto md:mt-5 md:text-xl lg:mx-0">
                Hotelier, easily enable integrations with all your applications.<br />
                SaaS provider, accelerate your market penetration and focus on features development.
              </p>
              <div className="mt-5 sm:mt-8 flex flex-col sm:flex-row sm:justify-center lg:justify-start space-y-2 sm:space-y-0 sm:space-x-4">
                <div className="w-full sm:w-auto">
                  <Link
                    to="/signup"
                    className="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-white bg-[#3C7CD6] hover:bg-[#4A8DE0] md:py-4 md:text-lg md:px-10"
                  >
                    For Hoteliers
                    <ArrowRight className="ml-2 h-5 w-5" />
                  </Link>
                </div>
                <div className="w-full sm:w-auto">
                  <Link
                    to="/signup?type=saas"
                    className="w-full flex items-center justify-center px-8 py-3 border border-[#3C7CD6] text-base font-medium rounded-md text-[#3C7CD6] bg-white hover:bg-blue-50 md:py-4 md:text-lg md:px-10"
                  >
                    For SaaS Providers
                    <ArrowRight className="ml-2 h-5 w-5" />
                  </Link>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
      <div className="lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2">
        <img
          className="h-56 w-full object-cover sm:h-72 md:h-96 lg:w-full lg:h-full"
          src="https://res.cloudinary.com/dqwmg4jgw/image/upload/v1742317753/hotel_hero_middle_o46vs5.jpg"
          alt="Modern hotel lobby"
        />
      </div>
    </div>
  );
}